import { Modal, Form, Input, Select, message } from "antd";
import { ExpenseType } from "@/types/expenseType";
import { useUpdateExpenseType } from "@/pages/Expenses/ManageExpense/hooks/useExpenseTypes";
import { EXPENSE_TYPE_FIELD_OPTIONS } from "@/constants/expenseType";
import { useEffect } from "react";
import { UpdateExpenseTypeFormValues } from "@/pages/Expenses/ManageExpense/api/expenseTypes";

interface EditModalProps {
  data?: ExpenseType;
  isOpen?: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
}

const EditModal = ({ data, isOpen, onClose, onSuccess }: EditModalProps) => {
  const [form] = Form.useForm();
  const { mutate: updateExpenseType, isPending } = useUpdateExpenseType();

  const handleSubmit = async (values: UpdateExpenseTypeFormValues) => {
    const payload: UpdateExpenseTypeFormValues = {
      ...values,
      id: data?.id || "",
      // worker_accessible: data?.worker_accessible || false,
      worker_accessible: true,
    };

    updateExpenseType(payload, {
      onSuccess: () => {
        message.success("Successfully updated expense type");
        form.resetFields();
        onClose?.();
        onSuccess?.();
      },
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose?.();
  };

  // Disable available fields for now
  // useEffect(() => {
  //   if (!availableFields) {
  //     return;
  //   }

  //   setRequiredFieldOptions(
  //     EXPENSE_TYPE_FIELD_OPTIONS.filter((field) =>
  //       availableFields.includes(field.value)
  //     )
  //   );

  //   const filteredRequiredFields = requiredFields?.filter((field: string) =>
  //     availableFields.includes(field)
  //   );
  //   form.setFieldValue("required_fields", filteredRequiredFields);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [availableFields, requiredFields]);

  useEffect(() => {
    if (!data) {
      return;
    }

    form.setFieldsValue(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Modal
      title="Edit Type"
      open={isOpen}
      onCancel={handleCancel}
      width={600}
      confirmLoading={isPending}
      onOk={form.submit}
      okText="Update"
      destroyOnHidden
    >
      <Form<UpdateExpenseTypeFormValues>
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={
          data && {
            name: data.name,
            description: data.description,
            // available_fields: data.available_fields,
            required_fields: data.required_fields,
          }
        }
      >
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input.TextArea />
        </Form.Item>
        {/* Disable available fields for now */}
        {/* <Form.Item
          name="available_fields"
          label="Available Fields"
          rules={[{ required: true }]}
        >
          <Select
            mode="multiple"
            placeholder="Select available fields"
            options={EXPENSE_TYPE_FIELD_OPTIONS}
          />
        </Form.Item> */}
        <Form.Item
          name="required_fields"
          label="Required Fields"
          rules={[{ required: true }]}
        >
          <Select
            mode="multiple"
            placeholder="Select required fields"
            options={EXPENSE_TYPE_FIELD_OPTIONS}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditModal;
